import React, { useEffect, useState, useCallback } from "react";
import ResellerPermissionForm from "./ResellerPermissionForm";
import ObjectList from "../../Common/ObjectList";
import ObjectListMobile from "../../Common/ObjectListMobile";
import http from "../../Common/RestAPIHandler";

const tableColumns = [
  {
    id: "permission_name",
    label: "NAME",
    minWidth: 200,
    sortable: true,
  },
  {
    id: "access_description",
    label: "Description",
    minWidth: 175,
    sortable: true,
  },
  {
    id: "order",
    label: "Order",
    minWidth: 175,
    sortable: true,
  },
  {
    id: "permission_category_name",
    label: "Category",
    minWidth: 175,
    sortable: true,
  },
];

const ResellerPermissions = (props) => {
  const [data, setData] = useState([]);
  const [loadData, setLoadData] = useState(false);
  const url = `reseller_permissions`;
  const actions = {
    delete: true,
    importCSV: false,
    exportCSV: false,
    exportPDF: false,
  };

  const fetchData = useCallback(() => {
    setLoadData(true);
    http.Get(
      url,
      (data) => {
        setData(data);
        setLoadData(false);
      },
      () => {
        setLoadData(false);
      }
    );
  }, [url]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
    {!props.mobile && 
    <ObjectList
      {...props}
      moduleName={"Reseller Permissions"}
      url={url}
      actions={actions}
      permissions={{
        create: ["Manage Users"],
        edit: ["Manage Users"],
        delete: ["Manage Users"],
      }}
      objectForm={ResellerPermissionForm}
      tableColumns={tableColumns}
      searchFields={["permission_name"]}
      orderBy={"permission_name"}
      data={data}
      fetchData={fetchData}
      pageHeader={"Reseller Permissions"}
      loadData={loadData}
    />
    }
    {props.mobile && 
    <ObjectListMobile
      {...props}
      moduleName={"Reseller Permissions"}
      url={url}
      actions={actions}
      permissions={{
        create: ["Manage Users"],
        edit: ["Manage Users"],
        delete: ["Manage Users"],
      }}
      objectForm={ResellerPermissionForm}
      tableColumns={tableColumns}
      searchFields={["name"]}
      orderBy={"name"}
      data={data}
      fetchData={fetchData}
      pageHeader={"Reseller Permissions"}
      loadData={loadData}
    />
    }
    </>
  );
};

export default ResellerPermissions;
